module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/venue_sola-5ef50ae2e1abda2b29b1f0d795f627e2.jpg";